import standardAction from '../../../utilities/standard-action';
import { ActionTypes } from '../constants';
import { RootActionTypes } from '../../../stores/types';

export default function toggleDialog(
  exportItem?: io.flow.v0.models.ScheduledExport,
): RootActionTypes {
  return standardAction(ActionTypes.TOGGLE_SCHEDULED_EXPORT_DIALOG, exportItem);
}
